var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-strict-ignore
import { Stack, Box } from "@mui/material";
import { MenuSection } from "./components";
import { useMemo } from "react";
import { useSectionInScrollView } from "../../../hooks";
import { COLORS } from "../../../constants";
/**
 * @param menuSections - List of sections (containing navItems) to display sections
 * @param sectionClassName - class name of each section to track, must exist for every element in menuSections
 * eg: <div id="example-section" class="${sectionClassName"> menuItem: {id: "example-section"}
 * @param offset - height of sticky header if exists
 * @param topPosition - how far from top for sticky positioning
 * @param bottomOverlayHeight - If there is a footer overlay that blocks content, this is the height of that overlay
 */
var ScrollingNav = function (_a) {
    var menuSections = _a.menuSections, sectionClassName = _a.sectionClassName, _b = _a.bottomOverlayHeight, bottomOverlayHeight = _b === void 0 ? 0 : _b, offset = _a.offset, _c = _a.topPosition, topPosition = _c === void 0 ? 0 : _c, loading = _a.loading, _d = _a.activeColor, activeColor = _d === void 0 ? COLORS.SAY_COBALT : _d;
    var activeNav = useSectionInScrollView({
        classname: sectionClassName,
        offset: offset,
        loading: loading,
        bottomOverlayHeight: bottomOverlayHeight,
    }).activeNav;
    var menuSectionsWithOffset = useMemo(function () {
        return menuSections.map(function (section, idx) {
            var _a;
            return (__assign(__assign({}, section), { offSet: ((_a = menuSections === null || menuSections === void 0 ? void 0 : menuSections[idx - 1]) === null || _a === void 0 ? void 0 : _a.menuItems.length) || 0 }));
        });
    }, []);
    // scroll to section when clicking menu item
    var handleClick = function (id) {
        var el = document.getElementById(id);
        if (el) {
            window.scroll({
                top: el.offsetTop - (offset + 10),
                left: 0,
                behavior: "smooth",
            });
        }
    };
    return (_jsx(Box, __assign({ "data-testid": "sticky-toc", top: topPosition, left: 0, position: "sticky" }, { children: _jsx(Box, { children: _jsx(Stack, __assign({ id: "stickyTableOfContents", direction: "row" }, { children: _jsx(Box, { children: menuSectionsWithOffset.map(function (section) { return (_jsx(MenuSection, { section: section, activeColor: activeColor, activeNav: activeNav, handleClick: handleClick, offSet: section.offSet, sectionsLength: menuSectionsWithOffset.length }, section.id)); }) }) })) }) })));
};
export default ScrollingNav;
